import React from 'react';
import AppHeader from 'components/AppHeader/AppHeader';
import Menu from 'components/Menu/Menu';
import { DesktopLayoutWrapper } from './DesktopLayout.styled';
import Utils from 'utils/utils';

const DesktopLayout = ({ isAuthenticated, showAppbar, children }) => {
  const handleLogout = () => {
    Utils.reAuthenticate();
  };

  return (
    <DesktopLayoutWrapper className={showAppbar ? 'app-container' : ''}>
      {isAuthenticated && showAppbar && (
        <>
          <div className="app-header">
            <AppHeader />
          </div>
          <div className="left-nav-wrapper">
            <Menu handleLogout={handleLogout} />
          </div>
        </>
      )}
      {children}
    </DesktopLayoutWrapper>
  );
};

export default DesktopLayout;
